import React from 'react';
import PropTypes from 'prop-types';
import { dates } from '@unite-us/client-utils';
import { hooks } from '../../../config/api';
import Spinner from '../../common/spinners/Spinner';
export var RejectionContent = function RejectionContent(_ref) {
  var _enrollmentRequest$en, _data$data;
  var enrollmentRequest = _ref.enrollmentRequest;
  var _hooks$useFindRecord = hooks.useFindRecord('enrollment_rejection_reason', (_enrollmentRequest$en = enrollmentRequest.enrollment_rejection_reason) === null || _enrollmentRequest$en === void 0 ? void 0 : _enrollmentRequest$en.id, {
      queryConfig: {
        placeholderData: undefined
      }
    }),
    data = _hooks$useFindRecord.data,
    isLoading = _hooks$useFindRecord.isLoading;
  var reason = (data === null || data === void 0 || (_data$data = data.data) === null || _data$data === void 0 ? void 0 : _data$data.data) || {};
  var requestType = enrollmentRequest.request_type;
  return isLoading ? /*#__PURE__*/React.createElement(Spinner, null) : /*#__PURE__*/React.createElement("div", {
    className: "text-sm"
  }, /*#__PURE__*/React.createElement("p", {
    className: "mb-2"
  }, "The ", requestType, "ment request submitted on\xA0", dates.formatDate(enrollmentRequest.created_at, 'MMM D, YYYY'), "\xA0 was rejected."), /*#__PURE__*/React.createElement("div", {
    className: "row space-y-2 items-baseline"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-sm-4 font-extrabold text-dark-blue"
  }, "Rejection Reason:"), /*#__PURE__*/React.createElement("div", {
    className: "col-sm-8"
  }, reason.display_name), /*#__PURE__*/React.createElement("div", {
    className: "col-sm-4 font-extrabold text-dark-blue"
  }, "Details:"), /*#__PURE__*/React.createElement("div", {
    className: "col-sm-8"
  }, reason.description), /*#__PURE__*/React.createElement("div", {
    className: "col-sm-4 font-extrabold text-dark-blue"
  }, "Note:"), /*#__PURE__*/React.createElement("div", {
    className: "col-sm-8"
  }, enrollmentRequest.rejection_note)));
};
RejectionContent.propTypes = {
  enrollmentRequest: PropTypes.object.isRequired
};
//# sourceMappingURL=RejectionContent.js.map